import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { UploadFilesComponent } from './upload.component';
import { DocumentFileModule } from '../../../documents/documentFile/documentFile.module';
import { WaitLoadingModule } from '../waitLoading/waitLoading.module';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  declarations: [UploadFilesComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    DocumentFileModule,
    FileUploadModule,
    WaitLoadingModule
  ],
  exports: [UploadFilesComponent]
})
export class UploadFilesModule { }
